// ไฟล์: frontend/src/components/Sidebar.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import authService from '../services/auth';

function Sidebar() {
  const location = useLocation();
  const currentUser = authService.getCurrentUser();
  const isAdmin = authService.isAdmin();

  const profilePicUrl = currentUser?.profile_pic
    ? `https://cms2568.backend.kruwirat.com/uploads/${currentUser.profile_pic}`
    : 'https://via.placeholder.com/150';

  const dashboardUrl = isAdmin ? '/admin/dashboard' : '/teacher/dashboard';
  const profileUrl = isAdmin ? '/admin/profile' : '/teacher/profile';

  return (
    <aside className="main-sidebar sidebar-dark-orange elevation-4">
      <Link to={dashboardUrl} className="brand-link">
        <img 
          src="https://www.i-pic.info/i/krVq1004512.jpg"
          alt="CMS Logo" 
          className="brand-image img-circle elevation-3"
        />
        <span className="brand-text font-weight-light">CMS:2025</span>
      </Link>

      <div className="sidebar">
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="image">
            <img 
              src={profilePicUrl} 
              className="img-circle elevation-2" 
              alt=""
            />
          </div>
          <div className="info">
            <Link to={profileUrl} className="d-block">
              {currentUser?.first_name} {currentUser?.last_name}
            </Link>
            <small className="text-muted d-block">
              {isAdmin ? 'ผู้ดูแลระบบ' : 'ครูผู้สอน'}
            </small>
          </div>
        </div>

        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {isAdmin ? (
              <>
                <li className="nav-item">
                  <Link to="/admin/dashboard" className={`nav-link ${location.pathname === '/admin/dashboard' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-tachometer-alt"></i>
                    <p>แดชบอร์ด</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/students" className={`nav-link ${location.pathname === '/admin/students' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-user-graduate"></i>
                    <p>จัดการนักเรียน</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/classes" className={`nav-link ${location.pathname === '/admin/classes' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-chalkboard"></i>
                    <p>จัดการชั้นเรียน</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/teachers" className={`nav-link ${location.pathname === '/admin/teachers' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-chalkboard-teacher"></i>
                    <p>จัดการครูผู้สอน</p>
                  </Link>
                </li>

                    {/* เพิ่มเมนูจัดการวิชาและตัวชี้วัด */}
    <li className="nav-item">
      <Link to="/admin/subjects" className={`nav-link ${location.pathname === '/admin/subjects' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-book"></i>
        <p>จัดการวิชาและตัวชี้วัด</p>
      </Link>
    </li>

                {/* เพิ่มเมนูการอบรมสำหรับแอดมิน */}
    <li className="nav-item">
      <Link to="/admin/training-courses" className={`nav-link ${location.pathname === '/admin/training-courses' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-book"></i>
        <p>จัดการหลักสูตรอบรม</p>
      </Link>
    </li>
    <li className="nav-item">
      <Link to="/admin/teacher-trainings" className={`nav-link ${location.pathname === '/admin/teacher-trainings' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-certificate"></i>
        <p>รายงานการอบรมครู</p>
      </Link>
    </li>

                <li className="nav-item">
                  <Link to="/admin/teacher-works" className={`nav-link ${location.pathname === '/admin/teacher-works' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-bookmark"></i>
                    <p>แฟ้มผลงานครู</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admin/profile" className={`nav-link ${location.pathname === '/admin/profile' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-user-cog"></i>
                    <p>ข้อมูลส่วนตัว</p>
                  </Link>
                </li>
              </>
            ) : (
              <>
                              <li className="nav-item">
                                <Link to="/admin/dashboard" className={`nav-link ${location.pathname === '/admin/dashboard' ? 'active' : ''}`}>
                                  <i className="nav-icon fas fa-tachometer-alt"></i>
                                  <p>แดชบอร์ด</p>
                                </Link>
                              </li>
                <li className={`nav-item has-treeview ${location.pathname.startsWith('/teacher/attendance') || location.pathname.startsWith('/teacher/savings') || location.pathname.startsWith('/teacher/health-records') || location.pathname.startsWith('/teacher/growth') || location.pathname.startsWith('/teacher/scores') ? 'menu-open' : ''}`}>
                  <a href="#" className={`nav-link ${location.pathname.startsWith('/teacher/attendance') || location.pathname.startsWith('/teacher/savings') || location.pathname.startsWith('/teacher/health-records') || location.pathname.startsWith('/teacher/growth') || location.pathname.startsWith('/teacher/scores') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-pencil-alt"></i>
                    <p>บันทึกข้อมูล<i className="right fas fa-angle-left"></i></p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/teacher/attendance" className={`nav-link ${location.pathname === '/teacher/attendance' ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>เข้าเรียน</p>
                      </Link>
                    </li>

                    <li className="nav-item">
      <Link to="/teacher/scores" className={`nav-link ${location.pathname === '/teacher/scores' ? 'active' : ''}`}>
        <i className="nav-icon far fa-circle"></i>
        <p>คะแนนเก็บ</p>
      </Link>
    </li>

                    <li className="nav-item">
                      <Link to="/teacher/savings" className={`nav-link ${location.pathname === '/teacher/savings' ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>ออมเงิน</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/teacher/health-records" className={`nav-link ${location.pathname === '/teacher/health-records' ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>แปรงฟันดื่มนม</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/teacher/growth" className={`nav-link ${location.pathname === '/teacher/growth' ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>น้ำหนักส่วนสูง</p>
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className={`nav-item has-treeview ${location.pathname.startsWith('/teacher/reports') || location.pathname.startsWith('/teacher/health-reports') || location.pathname.startsWith('/teacher/growth/reports')|| location.pathname.startsWith('/teacher/score-reports') ? 'menu-open' : ''}`}>
                  <a href="#" className={`nav-link ${location.pathname.startsWith('/teacher/reports') || location.pathname.startsWith('/teacher/health-reports') || location.pathname.startsWith('/teacher/growth/reports')|| location.pathname.startsWith('/teacher/score-reports') ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-chart-bar"></i>
                    <p>รายงาน<i className="right fas fa-angle-left"></i></p>
                  </a>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/teacher/reports" className={`nav-link ${location.pathname === '/teacher/reports' ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>การเข้าเรียน</p>
                      </Link>
                    </li>

                                        {/* เพิ่มเมนูคะแนนเก็บ */}
    <li className="nav-item">
      <Link to="/teacher/score-reports" className={`nav-link ${location.pathname === '/teacher/score-reports' ? 'active' : ''}`}>
        <i className="nav-icon far fa-circle "></i>
        <p>คะแนนเก็บ</p>
      </Link>
    </li>
    
                    <li className="nav-item">
                      <Link to="/teacher/health-reports" className={`nav-link ${location.pathname === '/teacher/health-reports' ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>แปรงฟันดื่มนม</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/teacher/growth/reports" className={`nav-link ${location.pathname === '/teacher/growth/reports' ? 'active' : ''}`}>
                        <i className="far fa-circle nav-icon"></i>
                        <p>น้ำหนักส่วนสูง</p>
                      </Link>
                    </li>

                  </ul>
                </li>

                 {/* เพิ่มเมนูการอบรมสำหรับครู */}
    <li className="nav-item">
      <Link to="/teacher/trainings" className={`nav-link ${location.pathname === '/teacher/trainings' ? 'active' : ''}`}>
        <i className="nav-icon fas fa-certificate"></i>
        <p>การอบรมของครู</p>
      </Link>
    </li>
                <li className="nav-item">
                  <Link to="/teacher/portfolios" className={`nav-link ${location.pathname === '/teacher/portfolios' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-folder-open"></i>
                    <p>แฟ้มผลงานนักเรียน</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/teacher/works" className={`nav-link ${location.pathname === '/teacher/works' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-bookmark"></i>
                    <p>แฟ้มผลงานครู</p>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link to="/teacher/profile" className={`nav-link ${location.pathname === '/teacher/profile' ? 'active' : ''}`}>
                    <i className="nav-icon fas fa-user-cog"></i>
                    <p>ข้อมูลส่วนตัว</p>
                  </Link>
                </li>
              </>
            )}

            <li className="nav-item">
              <a href="#" onClick={() => authService.logout()} className="nav-link">
                <i className="nav-icon fas fa-sign-out-alt"></i>
                <p>ออกจากระบบ</p>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
}

export default Sidebar;
